export default __webpack_public_path__ + "static/media/headerlogo2.bf48e50f.PNG";